import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <footer className="border-t border-white/5 bg-shark-950 px-4 py-12 text-white sm:px-6 lg:px-8 lg:py-16">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="/assets/images/logo.svg"
              alt="Velozent"
              className="h-8 w-auto contrast-[1.03] [transform:translateZ(0)] [backface-visibility:hidden] lg:h-9"
              decoding="async"
            />
            <p className="mt-4 text-sm leading-relaxed text-shark-400">
              Modern Healthcare Transformation & Innovation
            </p>
            <p className="mt-4 text-sm text-shark-500">
              5270 California Ave #200
              <br />
              Irvine, CA, 92679
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-shark-400">Services</p>
            <ul className="mt-4 space-y-2.5">
              {["Healthcare IT Services", "Cyber Security Solutions", "Cloud Services", "Advisory Services"].map((s) => (
                <li key={s}>
                  <NavLink to="what-we-do" className="text-sm text-shark-300 transition-colors hover:text-white">
                    {s}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-shark-400">Company</p>
            <ul className="mt-4 space-y-2.5">
              {[
                { name: "What We Do", path: "what-we-do" },
                { name: "Products", path: "products" },
                { name: "Who We Serve", path: "who-we-serve" },
                { name: "Why Velozent", path: "why-velozent" },
                { name: "Who We Are", path: "who-we-are" },
                { name: "Contact", path: "contact" },
              ].map((l) => (
                <li key={l.name}>
                  <NavLink to={l.path} className="text-sm text-shark-300 transition-colors hover:text-white">
                    {l.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-shark-400">Get in Touch</p>
            <div className="mt-4 space-y-2.5">
              <a href="mailto:connect@velozent.com" className="block text-sm text-shark-300 transition-colors hover:text-white">
                connect@velozent.com
              </a>
              <a href="tel:+19096393504" className="block text-sm text-shark-300 transition-colors hover:text-white">
                +1 909 639 3504
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-white/5 pt-8">
          <p className="text-center text-xs text-shark-500">
            &copy; {new Date().getFullYear()} Velozent. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
